import { PasswordResetEditForm } from '@/pages/PasswordResets/EditForm'

type TeamPasswordResetEditProps = {
  token: string
}

export default function TeamPasswordResetEdit({ token }: TeamPasswordResetEditProps) {
  return (
    <PasswordResetEditForm
      title="チームコーチ パスワード再設定"
      token={token}
      patchPath="/team/password_resets/:token"
    />
  )
}
